// extracted by mini-css-extract-plugin
export default {"head":"Catalog_head__10zv6","list":"Catalog_list__XJZTA","destination":"Catalog_destination__ulHKU","button":"Catalog_button__nmY5-"};